<template>
  <div>
    <v-card style="background: rgb(253,253,253);">
      <v-card-title class="grey lighten-3"><span class="headline">{{ headtitle }}</span></v-card-title>
      <v-form ref="form">
        <v-container fluid style="border-bottom: 1px solid rgba(0,0,0,.2);">
          <v-layout row wrap>
            <v-flex xs12 mb-3 mt-2>
              <v-checkbox
                hide-details
                off-icon="check_box_outline_blank"
                on-icon="check_box"
                color="primary"
                label="訂造"
                v-model="invoice['tailor']"
              ></v-checkbox>
            </v-flex>
            <v-flex xs6 sm3 offset-sm6>
              <v-select
                ref="send_state"
                :items="send_states"
                :item-text="(item) => item.text"
                :item-value="(item) => item.value"
                v-model="invoice['send_state']"
                label="傳送狀態"
                placeholder="請選擇..."
              ></v-select>
            </v-flex>
            <v-flex xs6 sm3>
              <v-text-field
                v-if="$store.state.user.detail.profile.admin"
                v-model="invoice['date']"
                label="日期"
                return-masked-value
                mask="####-##-##"
                placeholder="YYYY-MM-DD"
              ></v-text-field>
              <v-text-field
                v-else
                label="日期"
                :value="invoice['date']"
                disabled
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm3>
              <v-text-field
                ref="name"
                v-model="invoice['first_name']"
                :rules="[v => !!v || '必須項目', v => v && v.length > 20 ? '不能超過20個字' : true]"
                label="姓氏"
                placeholder="陳"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm3>
              <v-combobox
                ref="title"
                :rules="[v => !!v || '必須項目']"
                :items="titles"
                v-model="invoice['title']"
                label="稱謂"
                placeholder="請選擇..."
              ></v-combobox>
            </v-flex>
            <v-flex xs6 sm3>
              <v-text-field
                mask="#### ####"
                ref="primary_telephone"
                :rules="[v => !!v ? true : '必須項目', v => v && v.length !== 8 ? '請輸入正確的電話號碼' : true]"
                :value="invoice['primary_telephone'] && invoice['primary_telephone'].substr(4)"
                @input="invoice['primary_telephone']=$event && `+852${$event}`"
                label="首選電話"
                placeholder="9999 0000"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm3>
              <v-text-field
                mask="#### ####"
                :rules="[v => v && v.length !== 8 ? '請輸入正確的電話號碼' : true]"
                ref="second_telephone"
                :value="invoice['second_telephone'] && invoice['second_telephone'].substr(4)"
                @input="invoice['second_telephone']=$event && `+852${$event}`"
                label="後備電話"
                placeholder="6666 0000"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                ref="address"
                :rules="[v => !!v || '必須項目']"
                v-model="invoice['address']"
                label="地址"
                placeholder="荃灣街市街158號坤成樓地舖"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
        <v-container fluid style="border-bottom: 1px solid rgba(0,0,0,.2);">
          <v-layout row wrap>
            <v-flex xs12>
              <item-input
                ref="items"
                v-model="invoice['items']"
              ></item-input>
            </v-flex>
          </v-layout>
        </v-container>
        <v-container fluid style="border-bottom: 1px solid rgba(0,0,0,.2);padding-top: 30px;">
          <v-layout row wrap>
            <v-flex xs12>
              <file-select-input v-model="invoice['files']"/>
            </v-flex>
          </v-layout>
        </v-container>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs6>
              <v-checkbox
                off-icon="check_box_outline_blank"
                on-icon="check_box"
                hide-details
                color="primary"
                label="候電?"
                v-model="invoice['wait_for_call']"
              ></v-checkbox>
            </v-flex>
          </v-layout>
        </v-container>
        <v-divider
          inset
        ></v-divider>
        <v-container fluid style="border-bottom: 1px solid rgba(0,0,0,.2);">
          <v-layout row wrap>
            <v-flex xs12 sm6>
              <v-textarea
                name="side_note"
                label="訂單備註"
                v-model="invoice['side_note']"
              ></v-textarea>
            </v-flex>
            <v-flex xs12 sm6>
              <v-textarea
                name="private_note"
                label="公司備註"
                v-model="invoice['private_note']"
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-container>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs6>
              <v-text-field
                prefix="$"
                ref="total_price"
                v-model.number="invoice['total_price']"
                label="總數"
                disabled
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                prefix="$"
                ref="deposit"
                :rules="[v => parseInt(v) >= 0 || '必須項目']"
                v-model.number="invoice['deposit']"
                label="訂金"
                type="number"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                prefix="$"
                ref="balance"
                :value="balance"
                label="剩餘"
                disabled
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                prefix="$"
                ref="discount"
                :rules="[v => parseInt(v) >= 0 || '必須項目']"
                v-model.number="invoice['discount']"
                label="折扣"
                type="number"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-select
                ref="payment_method"
                :rules="[v => !!v || '必須項目']"
                :items="payment_methods"
                :item-text="(item) => item.text"
                :item-value="(item) => item.value"
                v-model="invoice['payment_method']"
                label="付款方式"
                placeholder="請選擇..."
                required
              ></v-select>
            </v-flex>
            <v-flex xs6>
              <v-select
                ref="source"
                :rules="[v => !!v || '必須項目']"
                :items="sources"
                :item-text="(item) => item.text"
                :item-value="(item) => item.value"
                v-model="invoice['source']"
                label="來源"
                placeholder="請選擇..."
                required
              ></v-select>
            </v-flex>
            <v-flex xs6></v-flex>
            <v-flex xs6>
              <manager-select v-if="profile.admin" v-model="invoice['salesman']" />
              <v-text-field
                v-else
                label="經手人"
                :value="`${profile.first_name} ${profile.last_name}`"
                disabled
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <div class="button-section">
      <div v-ripple class="submit-button" @click="submit" :class="{'loading': loading}">
        <div style="bottom: 25%;position: absolute;left: 50%;transform: translate(-50%, 50%);">
          <v-progress-circular
            :width="3"
            size="42"
            color="green"
            indeterminate
            v-if="loading"
          ></v-progress-circular>
          <v-icon large dark v-else>send</v-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import FileSelectInput from './FileSelectInput'
import ItemInput from './ItemInput'
import ManagerSelect from './ManagerSelect'

export default {
  name: 'new-invoice-sheet',
  props: {
    loading: Boolean,
    headtitle: String,
    submitFunc: Function,
    info: {
      type: Object,
      default: function() { return { tailor: false, wait_for_call: false, salesman: null, date: (() => {return new Date().toISOString().slice(0, 10)})(), branch: null, first_name: null, title: null, address: null, side_note: null, primary_telephone: null, second_telephone: null, items: [], total_price: 0, deposit: 0, discount: 0} }
    }
  },
  data () {
    return {
      invoice: _.cloneDeep(this.info),

      salesmen: [],
      titles: ["先生", "小姐", "女士", "太"]
    }
  },
  computed: {
    ...mapState({
      'profile': (state) => (state.user.detail && state.user.detail.profile) || {},
      payment_methods: state => state.options.options.PAYMENT_METHODS && state.options.options.PAYMENT_METHODS.map(method => ({ text: method[1], value: method[0] })),
      sources: state => state.options.options.SOURCE_TYPES && state.options.options.SOURCE_TYPES.map(method => ({ text: method[1], value: method[0] })),
      send_states: state => state.options.options.SEND_STATES && state.options.options.SEND_STATES.map(state => ({ text: state[1], value: state[0] }))
    }),
    disabled() {
      return this.loading
    },
    balance() {
      return this.invoice.total_price - this.invoice.deposit - this.invoice.discount
    }
  },
  watch: {
    info: {
      handler(x) {
        this.invoice = _.cloneDeep(x)
      },
      immediate: true
    },
    'invoice.items': {
      handler(x) {
        this.invoice['total_price'] = x ? x.reduce((total, item) => total + item.price * item.quantity, 0) : 0
      },
      deep: true
    }
  },
  methods: {
    submit () {
      if (this.$refs.form.validate()) {
        let data = _.cloneDeep(this.invoice)
        let info = _.cloneDeep(this.info)

        for (let key in data) {
          if (_.isEqual(info[key], data[key]))
            delete data[key]
        }
        
        this.submitFunc(data)
      }
    }
  },
  components: {
    ItemInput, FileSelectInput, ManagerSelect
  }
}
</script>

<style 
    ManagerSelectscoped>
.v-input--checkbox  {
  margin: 0;
}
.v-form>.container>.layout>.flex {
  padding: 0px 8px;
}
.disable {
  pointer-events: none;
}
.button-section {
  width: 100%;
  overflow: hidden;

  position: relative;
}
.submit-button {
  user-select: none;
  background: #cc392e;

  width: 100%;
  padding: 80px;

  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);

  transform: translateY(-50%);
  box-shadow: 0 2px 1px -1px rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 1px 3px 0 rgba(0,0,0,.12);

  cursor: pointer;
}
.submit-button:hover {
  background: #a32c23;
}
.submit-button.loading {
  background: rgb(245,245,245);
}
</style>



// WEBPACK FOOTER //
// src/components/NewInvoiceSheet.vue